module.exports = __webpack_public_path__ + "img/list1.a4090eb2.png";